import { render, staticRenderFns } from "./OrderListLocal.vue?vue&type=template&id=5ceca082&scoped=true"
import script from "./OrderListLocal.vue?vue&type=script&lang=js"
export * from "./OrderListLocal.vue?vue&type=script&lang=js"
import style0 from "./OrderListLocal.vue?vue&type=style&index=0&id=5ceca082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceca082",
  null
  
)

export default component.exports